import React, { ReactElement } from 'react';
import { MatchChoice } from './choices/matchChoice';
import MultiChoice from './choices/multiChoice';
import TrafficChoice from './choices/trafficLight';
import TrueOrFalse from './choices/trueOrFalse';
import { QuestionResponseType } from '@/modules/types/choice';

export const responseTypeOptions = [
  {
    label: 'Multiple-option',
    value: QuestionResponseType.singleAnswer,
  },
  {
    label: 'Multi-correct',
    value: QuestionResponseType.multiCorrect,
  },
  {
    label: 'True or False',
    value: QuestionResponseType.trueOrFalse,
  },
  {
    label: 'Match - Drag & drop',
    value: QuestionResponseType.match,
  },
  {
    label: 'Order - Drag & drop',
    value: QuestionResponseType.order,
  },
  {
    label: 'Traffic light',
    value: QuestionResponseType.trafficLight,
  },
];

export const Choices = ({
  responseType,
}: {
  responseType: QuestionResponseType;
}): ReactElement => {
  switch (responseType) {
    case 1:
      return <MultiChoice key={responseType} type="radio" />;
    case 2:
      return <MultiChoice key={responseType} type="checkbox" />;
    case 3:
      return <TrueOrFalse key={responseType} />;
    case 4:
      return <MatchChoice key={responseType} />;
    case 5:
      return <MultiChoice key={responseType} type="order" />;
    case 6:
      return <TrafficChoice key={responseType} />;

    default:
      return <span>No response type selected</span>;
  }
};

export default Choices;
